
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
    Table,
} from "reactstrap";

import Api from "services/api"
// import AddInviteInterpreter from "components/inviteInterpreter/AddInviteInterpreter";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { SearchBar } from "components/common/SearchBar";
import { removeMultipleInviteInterpreter } from "slices/inviteInterpreterSlice";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { SortButtons } from "components/common/SortButtons";
import { fetchInviteInterpreters } from "slices/inviteInterpreterSlice";
// import { otherInviteInterpreterSelector } from "slices/otherInviteInterpreterSlice";
// import { fetchOtherInviteInterpreters } from "slices/otherInviteInterpreterSlice";
import { addInviteInterpreter } from "slices/inviteInterpreterSlice";
import { removeInviteInterpreter } from "slices/inviteInterpreterSlice";
import FullPageLoader from "components/common/FullPageLoader";
import { inviteInterpretersSelector } from "slices/inviteInterpreterSlice";
import { fetchAppointmentsInterpreters } from "slices/inviteInterpreterSlice";
import { addInviteInterpreters } from "slices/inviteInterpreterSlice";
import InterpretersWithAppointments from "./InterpretersWithAppointments";
import AppointedInterpretersList from "./AppointedInterpretersList";
import Swal from "sweetalert2";
import { fetchAppointmentView } from "slices/inviteInterpreterSlice";
import { appointmentsSelector, callInterpreters } from "slices/appointmentSlice";
import { fetchInvitedInterpreters } from "slices/inviteInterpreterSlice";


const apiService = new Api();
function InviteInterpreterList({ itemId, appointmentData , isModal = false}) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [showInvitedList, setInvitedList] = useState(false);
    const [selectedIndividual, setSelectedIndividual] = useState([]);
    const [selectedAgency, setSelectedAgency] = useState([]);

    const fetchingList = async () => {
        setLoading(true)
        // await dispatch(fetchAppointmentsInterpreters(itemId))
        // await dispatch(fetchAppointmentView(itemId))
        const rawGender = appointmentData?.appointment_details?.interpreter_gender 
            || appointmentData?.appointment_details?.gender 
            || appointmentData?.gender 
            || appointmentData?.interpreter_gender;
        const normalizedGender = typeof rawGender === 'string' ? rawGender.trim().toLowerCase() : '';
        const activeGender = Boolean(normalizedGender && !['no_preference', 'all', 'null', 'undefined'].includes(normalizedGender) && ['male', 'female'].includes(normalizedGender))
            ? normalizedGender
            : undefined;

        await Promise.all([
            // dispatch(fetchAppointmentsInterpreters(itemId, { exclude_invited: true })),
            dispatch(fetchAppointmentsInterpreters(itemId, { 
                exclude_invited: true,
                gender: activeGender,
                interpreter_gender: activeGender
            })),
            dispatch(fetchInvitedInterpreters(itemId)),
            dispatch(fetchAppointmentView(itemId))
        ])
        setLoading(false)
    }
    React.useEffect(() => {
        fetchingList()
    }, [])


    const handleInvitedList = React.useCallback(() => {
        setInvitedList(true);
        // scroll to this div interperters-with-appt

    }, [showInvitedList])

    useEffect(() => {
        if (showInvitedList) {
            const element = document.getElementById("interperters-with-appt");
            element.scrollIntoView({ behavior: "smooth" });
        }
    }, [showInvitedList])

    const totalBothSelected = selectedIndividual.length + selectedAgency.length;

    const handleInviteBoth = React.useCallback(() => {
        const allSelectedIds = Array.from(new Set([...selectedIndividual, ...selectedAgency]));
        if (allSelectedIds.length === 0) return;

        const submitCallback = (status, message) => {
            if (status) {
                toast.success(message, {
                    className: "successToast",
                });
                setSelectedIndividual([]);
                setSelectedAgency([]);
                dispatch(fetchInvitedInterpreters(itemId));
                dispatch(fetchAppointmentView(itemId));
                dispatch(fetchAppointmentsInterpreters(itemId, { exclude_invited: true }));
            } else {
                toast.error(message, {
                    className: "errorToast",
                });
            }
        };

        new Swal({
            title: "Are you sure?",
            text: "You want to invite both individual and agency vendors?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#075665",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(addInviteInterpreters({ interpreter_ids: allSelectedIds }, itemId, submitCallback));
            }
        });
    }, [selectedIndividual, selectedAgency, itemId, dispatch]);

    const handleCallBoth = React.useCallback(() => {
        const allSelectedIds = Array.from(new Set([...selectedIndividual, ...selectedAgency]));
        if (allSelectedIds.length === 0) return;

        new Swal({
            title: "Are you sure?",
            text: `You want to call all selected vendors (${allSelectedIds.length} vendors from both individual and agency)?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#075665",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Call"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(callInterpreters(itemId, { interpreter_ids: allSelectedIds }, (status, message) => {
                    if (status) {
                        toast.success(message || "Call initiated successfully", { className: "successToast" });
                    } else {
                        toast.error(message || "Failed to initiate call", { className: "errorToast" });
                    }
                }));
            }
        });
    }, [selectedIndividual, selectedAgency, itemId, dispatch]);

    return (
        <>
            {/* <InviteInterpreters height={'height-auto'} itemId={itemId} appointmentData={appointmentData} mainLoader={loading} handleInvitedList={handleInvitedList} invitedList={showInvitedList} fetchAppointment={fetchingList} isModal={isModal} />
            <AppointedInterpretersList height={'height-auto'} itemId={itemId} appointmentData={appointmentData} handleInvitedList={handleInvitedList} invitedList={showInvitedList} fetchAppointment={fetchingList} /> */}


            {/* INDIVIDUAL VENDORS SECTION */}
            <InviteInterpreters
                height={'height-auto'}
                itemId={itemId}
                appointmentData={appointmentData}
                mainLoader={loading}
                handleInvitedList={handleInvitedList}
                invitedList={showInvitedList}
                fetchAppointment={fetchingList}
                isModal={isModal}
                vendorType="individual"
                selectedItems={selectedIndividual}
                setSelectedItems={setSelectedIndividual}
                onInviteBoth={handleInviteBoth}
                onCallBoth={handleCallBoth}
                totalBothSelected={totalBothSelected}
            />
            <AppointedInterpretersList
                height={'height-auto'}
                itemId={itemId}
                appointmentData={appointmentData}
                handleInvitedList={handleInvitedList}
                invitedList={showInvitedList}
                fetchAppointment={fetchingList}
                vendorType="individual"
            />

            {/* AGENCY VENDORS SECTION */}
            {/* <div style={{ marginTop: 35 }}> */}
                <InviteInterpreters
                    height={'height-auto'}
                    itemId={itemId}
                    appointmentData={appointmentData}
                    mainLoader={loading}
                    handleInvitedList={handleInvitedList}
                    invitedList={showInvitedList}
                    fetchAppointment={fetchingList}
                    isModal={isModal}
                    vendorType="agency"
                    selectedItems={selectedAgency}
                    setSelectedItems={setSelectedAgency}
                    onInviteBoth={handleInviteBoth}
                    onCallBoth={handleCallBoth}
                    totalBothSelected={totalBothSelected}
                />
                <AppointedInterpretersList
                    height={'height-auto'}
                    itemId={itemId}
                    appointmentData={appointmentData}
                    handleInvitedList={handleInvitedList}
                    invitedList={showInvitedList}
                    fetchAppointment={fetchingList}
                    vendorType="agency"
                />
            {/* </div> */}

            {showInvitedList && <InterpretersWithAppointments height={'height-auto'} itemId={itemId} showInvitedList={showInvitedList} />}

            <div id="interperters-with-appt">   </div>

            <div className={isModal && 'inviteModalLoader'}>
            {loading && <FullPageLoader />}
            </div>
        </>

    )
}

const InviteInterpreterItem = ({
    item, index, selectedItems, handleChange, handleAddPopUp, handleCallSingle
}) => {
    const dispatch = useDispatch();

    const displayName = (item?.first_name ? `${item.first_name} ${item.last_name || ''}` : item?.name || '').trim();
    const email = item?.user?.email || item?.email || '-';
    const phone = item?.phone || '-';
    const languages = item?.languages?.map(l => l?.language?.name).filter(Boolean).join(", ") || '-';

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{index + 1}</span>
                    <label className="custom-checkbox checkbox">
                        <input type="checkbox" name="select-all" data-value={item?.id} checked={selectedItems?.includes(item?.id?.toString())} onChange={handleChange} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </td>
            {/* <td>
                <a className='link_preview' target="_blank" href={`/interpreters/update/${item?.id}`}>
                    {item?.code}
                </a>
            </td> */}
            <td>
                <a className='link_preview' target="_blank" href={`/interpreters/update/${item?.id}`}>
                    {displayName}
                </a>
            </td>
            <td>
                {email}
            </td>
            <td>
                {phone}
            </td>
            <td>
                {languages}
            </td>
            <td>
                <button
                    type="button"
                    className="main_button green"
                    style={{padding: '16px 14px'}}
                    onClick={() => handleCallSingle && handleCallSingle(item)}
                >
                    <i className="fa-solid fa-phone"></i> Call
                </button>
            </td>

        </tr>
    )
}

const InviteInterpreters = ({
    mainLoader,
    handleInvitedList,
    invitedList,
    itemId,
    appointmentData,
    height,
    isModal,
    vendorType,
    selectedItems: propSelectedItems,
    setSelectedItems: propSetSelectedItems,
    onInviteBoth,
    onCallBoth,
    totalBothSelected,
}) => {
    const dispatch = useDispatch()
    const { inviteInterpreters, last_page: totalPages, loader, allInterpreters, invitedInterpreters } = useSelector(inviteInterpretersSelector);

    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}

    });
    const navigate = useNavigate()
    const refAddutton = React.useRef(null);

    // useEffect(() => {

    //     if (
    //         appointmentData &&
    //         appointmentData?.status !== 'available'
    //     ) {

    //         toast.error('This appointment is no longer available.');

    //         navigate(-1);

    //     }

    // }, [appointmentData]);
    
    const [localSelectedItems, setLocalSelectedItems] = React.useState([]);
    const selectedItems = propSelectedItems !== undefined ? propSelectedItems : localSelectedItems;
    const setSelectedItems = propSetSelectedItems !== undefined ? propSetSelectedItems : setLocalSelectedItems;
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });

    const invitedInterpreterIds = React.useMemo(() => {
        const invites = invitedInterpreters?.invites || [];
        return new Set(
            invites
                .map((inv) => inv?.interpreter_id || inv?.interpreter?.id)
                .filter(Boolean)
                .map(String)
        );
    }, [invitedInterpreters]);

    const filteredInterpreters = React.useMemo(() => {
        if (!allInterpreters) return [];
        const uninvited = allInterpreters.filter(
            (item) => !invitedInterpreterIds.has(String(item?.id))
        );
        if (vendorType === "agency") {
            return uninvited.filter((item) => item?.vendor_type === "agency");
        }
        if (vendorType === "individual") {
            // return uninvited.filter((item) => item?.vendor_type !== "agency");
            let individuals = uninvited.filter((item) => item?.vendor_type !== "agency");
            const rawGender = appointmentData?.appointment_details?.interpreter_gender 
                || appointmentData?.appointment_details?.gender 
                || appointmentData?.gender 
                || appointmentData?.interpreter_gender;
            const normalizedGender = typeof rawGender === 'string' ? rawGender.trim().toLowerCase() : '';
            const hasGenderFilter = Boolean(normalizedGender && !['no_preference', 'all', 'null', 'undefined'].includes(normalizedGender) && ['male', 'female'].includes(normalizedGender));
            if (hasGenderFilter) {
                individuals = individuals.filter((item) => {
                    const itemGender = (item?.gender || item?.user?.gender || '').trim().toLowerCase();
                    return itemGender === normalizedGender;
                });
            }
            return individuals;
        }
        return uninvited;
    }, [allInterpreters, invitedInterpreterIds, vendorType, appointmentData]);

    React.useEffect(() => {
        if (selectedItems.length === 0) {
            setSelectAll(false);
        } else if (filteredInterpreters?.length > 0 && selectedItems.length === filteredInterpreters.length) {
            setSelectAll(true);
        }
    }, [selectedItems, filteredInterpreters]);

    React.useEffect(() => {
        if (selectedItems.length > 0) {
            const availableIds = new Set(filteredInterpreters.map((i) => i?.id?.toString()));
            const validSelected = selectedItems.filter((id) => availableIds.has(id));
            if (validSelected.length !== selectedItems.length) {
                setSelectedItems(validSelected);
            }
        }
    }, [filteredInterpreters]);

    const handlePageChange = React.useCallback((page) => {
        setCurrentPage(page);
        dispatch(fetchInviteInterpreters(page));
    }, [])
    const handleAddInviteInterpreterPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }

    const handleSubmitInviteInterpreters = React.useCallback(() => {
        const submitCallback = (status, message) => {
            if (status) {
                toast.success(message, {
                    className: "successToast",
                })
                setSelectedItems([]);
                setSelectAll(false)
                // dispatch(fetchInviteInterpreters())
                dispatch(fetchInvitedInterpreters(itemId))
                dispatch(fetchAppointmentView(itemId))
                dispatch(fetchAppointmentsInterpreters(itemId, { exclude_invited: true }))

                //   dispatch(fetchOtherInviteInterpreters())
                hideConfirmDialog()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
            }
        };

        const confirmText = vendorType === "agency"
            ? "You want to invite these agency vendors?"
            : vendorType === "individual"
            ? "You want to invite these individual vendors?"
            : "You want to invite these vendors?";

        new Swal({
            title: "Are you sure?",
            // text: "You want to invite these vendors?",
            text: confirmText,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#075665",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(addInviteInterpreters({ interpreter_ids: selectedItems, }, itemId, submitCallback))
            }
        })
    }, [selectedItems, itemId, vendorType])

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = React.useCallback(() => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
    //     setSelectedItems(allInterpreters.map((inviteInterpreter) => inviteInterpreter.id.toString()))
    // }, [selectedItems, selectAll, allInterpreters])


        setSelectedItems(filteredInterpreters.map((inviteInterpreter) => inviteInterpreter.id.toString()))
    }, [selectedItems, selectAll, filteredInterpreters, setSelectedItems])

    const handleCallSingle = React.useCallback((item) => {
        if (!item?.id) return;
        if (!item?.phone || item?.phone === '-') {
            toast.error("This vendor does not have a valid phone number.", { className: "errorToast" });
            return;
        }
        const displayName = (item?.first_name ? `${item.first_name} ${item.last_name || ''}` : item?.name || '').trim();
        new Swal({
            title: "Are you sure?",
            text: `You want to call ${displayName || 'this vendor'}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#075665",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Call"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(callInterpreters(itemId, { interpreter_ids: [item.id] }, (status, message) => {
                    if (status) {
                        toast.success(message || "Call initiated successfully", { className: "successToast" });
                    } else {
                        toast.error(message || "Failed to initiate call", { className: "errorToast" });
                    }
                }));
            }
        });
    }, [itemId, dispatch]);

    const handleCallSelectedInterpreters = React.useCallback(() => {
        if (!selectedItems || selectedItems.length === 0) return;

        const confirmText = vendorType === "agency"
            ? "You want to call all selected agency vendors?"
            : "You want to call all selected vendors?";

        new Swal({
            title: "Are you sure?",
            text: confirmText,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#075665",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Call"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(callInterpreters(itemId, { interpreter_ids: selectedItems }, (status, message) => {
                    if (status) {
                        toast.success(message || "Call initiated successfully", { className: "successToast" });
                    } else {
                        toast.error(message || "Failed to initiate call", { className: "errorToast" });
                    }
                }));
            }
        });
    }, [selectedItems, itemId, vendorType, dispatch]);

    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                    </div>
                </th>
                {/* <th className="col-1">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Code</p>
                    </div>
                </th> */}
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Phone</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Languages</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Action</p>
                    </div>
                </th>

            </tr>
        )
    }, [selectedItems, filteredInterpreters, selectAll, handleToggleSelectAll])

    const renderTableContent = React.useCallback(() => {

        return (
            // allInterpreters?.map((item, index) => {
            //     return <InviteInterpreterItem item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInviteInterpreterPopUp} />
            // })
            filteredInterpreters?.map((item, index) => {
                return <InviteInterpreterItem key={item?.id || index} item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInviteInterpreterPopUp} handleCallSingle={handleCallSingle} />
            })
        )
    }, [filteredInterpreters, selectedItems, handleCallSingle, handleChange, handleAddInviteInterpreterPopUp]);

    const handleClose = React.useCallback(() => {
        refAddutton.current.click();
        setAddForm({ show: false })
    }, [])


    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };

    const renderFooter = React.useCallback(() => {

        const callBtnText = vendorType === "agency"
            ? "Call All Selected Agency"
            : "Call All Selected Vendor";

        const btnText = vendorType === "agency"
            ? "Invite Agency Vendors"
            : vendorType === "individual"
            ? "Invite Individual Vendors"
            : "Invite Vendors";

        return (
            <div className="row-primary" style={{gap: 0}}>

                {selectedItems?.length > 0 && (
                    <button
                        onClick={handleCallSelectedInterpreters}
                        className="main_button green"
                        style={{

                            // float: "right",
                            marginRight: 20
                        }}
                    >
                        {callBtnText}
                    </button>
                )}
                <button
                    onClick={handleSubmitInviteInterpreters}
                    disabled={selectedItems?.length == 0}
                    className="main_button"
                    style={{

                        // float: "right",
                        marginRight: 20
                    }}
                >
                    {btnText}
                </button>

                {/* <button
                    onClick={handleInvitedList}
                    className="main_button"
                    style={{

                        // float: "right",
                        marginRight: 20
                    }}
                >
                    Interpreters with Appointment
                </button> */}
            </div>
        )
    }, [selectedItems, invitedList, handleInvitedList, vendorType, handleSubmitInviteInterpreters, handleCallSelectedInterpreters])

    const getHeading = () => {
        const label = vendorType === "agency"
            ? "Agency Vendors"
            : vendorType === "individual"
            ? "Individual Vendors"
            : "Vendors";

        if (isModal) {
            return `Invite ${label}`;
        }
        return `Invite ${label} (${appointmentData?.appid || ''})`;
    };

    const getTitle = () => {
        if (vendorType === "agency") return "Agency Vendors";
        if (vendorType === "individual") return "Individual Vendors";
        return "Vendors";
    };

    const renderHeaderRight = () => {
        if (vendorType !== "individual") return null;
        return (
            <div className="d-flex align-items-center gap-2">
                {onCallBoth && (
                    <button
                        onClick={onCallBoth}
                        disabled={!totalBothSelected || totalBothSelected === 0}
                        className="main_button green"
                    >
                        Call Both
                    </button>
                )}
                {onInviteBoth && (
                    <button
                        onClick={onInviteBoth}
                        disabled={!totalBothSelected || totalBothSelected === 0}
                        className="main_button"
                    >
                        Invite Both
                    </button>
                )}
            </div>
        );
    };

    return (
        <>
            <ListLayout
                heading={getHeading()}
                time={false}
                height={height}
                title={getTitle()}
                addButtonDisabled={true}
                buttonTitle={`Add ${getTitle()}`}
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                totalPages={totalPages}
                fetchList={fetchInviteInterpreters}
                selectedItems={selectedItems}
                // handleRemoveItems={handleRemoveItems}
                // renderAddForm={<AddInviteInterpreter item={addForm.item} show={addForm.show} onClose={handleClose} />}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddInviteInterpreterPopUp}
                renderFooter={renderFooter}
                headerRight={renderHeaderRight}
                hideRemoveButton={true}
                // loader={mainLoader}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                haveBackBtn={!isModal && vendorType !== "agency"}
                onBackButtonClick={
                    isModal ? undefined : () => navigate(`/appointments/view/${appointmentData?.id}`)
                }
            >
            </ListLayout>
        </>
    )

}

export default InviteInterpreterList;
